import axios from "axios";

export async function keywords(csrf_url, main_api) {
  const cachedKeywords = localStorage.getItem("keywords");
  if (cachedKeywords && cachedKeywords !== "undefined") {
    return cachedKeywords;
  }

  try {
    await axios.get(csrf_url);
    const response = await axios.get(`${main_api}/products/keywords`, {
      headers: {},
    });
    const results = Array.prototype.map
      .call(response.data, (item) => item.product)
      .join(",");
    localStorage.setItem("keywords", results);
    return results;
  } catch (error) {
    return "";
  }
}